const TopUpPaymentModalInfo = ({ data }) => {
  const currency = data?.currency || ''

  return (
    <div className="shadow-modal-light w-[480px] mr-[20px] p-[24px] rounded-[10px] border-[#FFCA84] border-[1px] bg-[#FFF5EE]">
      <div className="w-full flex flex-col items-start p-[20px] rounded-[10px] border-[#FFE4D4] border-[1px] bg-white gap-y-[16px]">
        <div className="w-full flex items-end justify-between">
          <span className="text-[14px] text-primary-100 font-medium">Your balance</span>

          {/* TODO */}
          <span className="text-sm text-primary-100 font-semibold">
            {currency === 'EUR' && <span className="font-normal">€</span>} 0{' '}
            {currency !== 'EUR' && currency}
          </span>
        </div>

        <div className="w-full flex items-end justify-between">
          <span className="text-[14px] text-primary-100 font-medium">Top Up Amount</span>

          {/* TODO */}
          <span className="text-sm text-primary-100 font-semibold">
            {currency === 'EUR' && <span className="font-normal">€</span>} 50{' '}
            {currency !== 'EUR' && currency}
          </span>
        </div>

        <div className="w-full flex items-end justify-between">
          <span className="text-[14px] text-primary-100 font-medium">
            Your Balance after Top Up
          </span>

          {/* TODO */}
          <span className="text-sm text-primary-100 font-semibold">
            {currency === 'EUR' && <span className="font-normal">€</span>} 50{' '}
            {currency !== 'EUR' && currency}
          </span>
        </div>
      </div>

      <div className="mt-[24px] w-full flex flex-col items-start">
        <span className="text-base font-bold text-primary-100">Your Payment Details</span>

        <div className="w-full flex flex-col items-start gap-y-[10px] mt-[10px]">
          <div className="w-full flex items-center justify-between">
            <span className="text-base font-normal text-primary-100">Top Up Amount</span>

            <span className="text-sm text-primary-100 font-semibold">
              {currency === 'EUR' && <span className="font-normal">€</span>} 50{' '}
              {currency !== 'EUR' && currency}
            </span>
          </div>

          <div className="w-full flex items-center justify-between">
            <span className="text-base font-normal text-primary-100">Top Up Price</span>

            <span className="text-sm text-primary-100 font-semibold">
              {currency === 'EUR' && <span className="font-normal">€</span>} 47.5{' '}
              {currency !== 'EUR' && currency}
            </span>
          </div>
        </div>

        <div role="separator" className="mt-[10px] w-full h-[1px] bg-[rgba(247,144,9,0.40)]" />

        <div className="w-full flex flex-col items-start gap-y-[10px] mt-[24px]">
          <div className="w-full flex items-center justify-between">
            <span className="text-base font-bold text-primary-100">Total Payment</span>

            <span className="text-base text-primary-100 font-bold">
              {currency === 'EUR' && <span className="font-normal">€</span>} 47.5{' '}
              {currency !== 'EUR' && currency}
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TopUpPaymentModalInfo
